import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from '../../api/axios';
import styles from "./Admin.module.css";
import LoadingModal from "../LoadingModal";

const defaultStatus = "active";
const statuses = [
    { display: "Active", value: "active" },
    { display: "Archived", value: "archived" },
    { display: "Deleted", value: "deleted" },
]

const validTextRegex = /(.|\s)*\S(.|\s)*/

const EditPollCategory = () => {

    const navigate = useNavigate();

    let { pollCategoryId } = useParams();
    if (pollCategoryId !== undefined) {
        pollCategoryId = parseInt(pollCategoryId);
    }

    const [category, setCategory] = useState("");
    const [status, setStatus] = useState(defaultStatus);

    const [categoryCopy, setCategoryCopy] = useState("");
    const [statusCopy, setStatusCopy] = useState(defaultStatus);

    const [validCategory, setValidCategory] = useState(false);

    const [isSaving, setIsSaving] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [hasChanged, setHasChanged] = useState(false);

    const parseResponse = (response) => {
        if (response && response.data) {

            console.log(JSON.stringify(response?.data));

            for (let category of response.data) {
                if (category.pollCategoryId === pollCategoryId) {
                    setCategory(category.category);
                    setCategoryCopy(category.category);
                    setStatus(category.status);
                    setStatusCopy(category.status);
                    setIsSaving(false);
                    setDataLoaded(true);

                    break;
                }
            }
        } else {
            console.log("Error: response is not valid");
        }


    }

    const saveChanges = () => {
        if (pollCategoryId === undefined) {
            saveNewPollCategory();
        } else {
            saveUpdatedPollCategory();
        }
    }
    const saveUpdatedPollCategory = async () => {
        if (!validCategory) {
            return;
        }

        const json = {};

        json.category = category;
        json.status = status;
        console.log(json);

        if (
            (category !== categoryCopy) ||
            (status !== statusCopy)
        ) {
            setIsSaving(true);
            try {
                const response = await axios.patch(`/pollcategories/${pollCategoryId}`,
                    JSON.stringify(json),
                    {
                        headers: { 'Content-Type': 'application/json' }
                    }
                );
                parseResponse(response);

            } catch (err) {
                console.log(err);
                // if (!err?.response) {
                //     setErrMsg('No Server Response');
                // } else if (err.response?.status === 409) {
                //     setErrMsg('Email Taken');
                // } else {
                //     setErrMsg('Registration Failed')
                // }
                // errRef.current.focus();
            }

        }

    }
    const saveNewPollCategory = async () => {
        if (!validCategory) {
            return;
        }

        const json = {};

        json.category = category;
        json.status = status;

        setIsSaving(true);

        console.log(json);

        try {
            const response = await axios.post(`/pollcategories`,
                JSON.stringify(json),
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            pollCategoryId = response.data[0].pollCategoryId;

            navigate(`/insightscategory/edit/${pollCategoryId}`, { replace: true });

        } catch (err) {
            console.log(err);
            // if (!err?.response) {
            //     setErrMsg('No Server Response');
            // } else if (err.response?.status === 409) {
            //     setErrMsg('Email Taken');
            // } else {
            //     setErrMsg('Registration Failed')
            // }
            // errRef.current.focus();
        }

        // }

    }

    useEffect(() => {

        let isMounted = true;

        const controller = new AbortController();

        if (pollCategoryId !== undefined) {
            const getPollCategory = async () => {

                setIsSaving(true);

                try {
                    const response = await axios.get(`/pollcategories/${pollCategoryId}`, {
                        signal: controller.signal
                    });
                    console.log(response.data);
                    if (isMounted) {
                        parseResponse(response);
                    }
                } catch (err) {
                    if (isMounted) {
                        console.error(err);
                        // if (err.response?.status === 403) {
                        //     navigate('/login', { state: { from: location }, replace: true });
                        // }
                    }
                }
            }

            getPollCategory();
        } else {
            setCategory("New insights category");
            setDataLoaded(true);
            setIsSaving(false);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setValidCategory(validTextRegex.test(category));
    }, [category]);

    useEffect(() => {
        const changed = (category !== categoryCopy) || (status !== statusCopy);
        console.log(`category: ${category}, categoryCopy: ${categoryCopy}, status: ${status}, statusCopy: ${statusCopy} changed: ${changed}`);
        setHasChanged(changed);
    }, [category, categoryCopy, status, statusCopy]);



    if (!dataLoaded) {
        return <LoadingModal />;
    }

    console.log(`EditPollCategory: render at ${new Date().getTime()}`);

    return (
        <section className={styles.admin}>
            <p><Link to="/admin">Admin</Link> &gt; <Link to="/insightscategories">Insights Categories</Link> &gt; {category}</p>
            <h3 className={styles.noBorder}>Insights category</h3>
            <input type="text" id="category" name="category" autoComplete="off" maxLength="100" placeholder="New insights category" value={category} onChange={e => setCategory(e.target.value)} />
            <h3>Status:</h3>
            {
                statuses.map((option, i) => {
                    return (
                        <div key={i} className="radio-button-and-label">
                            <input type="radio" id={option.value} name="status" value={option.value} onChange={(e) => setStatus(e.target.value)} checked={status === option.value} />
                            <label htmlFor={option.value}>{option.display}</label>
                        </div>
                    )
                })
            }
            <button disabled={!validCategory || isSaving || !hasChanged} onClick={saveChanges}>Save changes</button>

        </section>
    );

};

export default EditPollCategory;